export enum ConversationSubType {
  DEFAULT = 'default',
  GENERAL = 'general',
  BOT = 'bot'
}
